import * as Yup from 'yup'

import flow from 'lodash/fp/flow'

import email from '@galo-monitor/forms/validators/email.validator'
import phone from '@galo-monitor/forms/validators/phone.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const clientCompanySchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  name_responsible: required({ t })(Yup.string()),
  email: flow(
    email({ t }),
    required({ t })
  )(Yup.string()),
  phone: flow(
    phone({ t }),
    required({ t })
  )(Yup.string())
})

export default clientCompanySchema
